<template lang="pug">
.row
  .col-xs-9
    vue-slider(v-model="serviceAnswerDetail.point", :class="serviceAnswerDetail.point > 0 ? 'answered-slider' : 'no-answer-slider'" dotSize=24, height="8px", :enable-cross="false" :interval="1" :min="0", :data="data(serviceAnswerDetail.attributes['max-point'])" :max="Number(serviceAnswerDetail.attributes['max-point'])", :marks="true", ref="slider", @change="handleChange($event)")
  .col-xs-3
    p.no-answer-warning(v-if="!serviceAnswerDetail.point") 未回答
</template>
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
  name: 'service-answer-edit-slider',
  props: {
    index: {
      type: Number,
      default: 0
    },
    serviceAnswerDetail: {
      type: Object,
      default: null
    }
  },
  mounted () {
    // マウント時にmousedownイベントリスナーを設定
    this.$refs.slider.$el.addEventListener('mousedown', this.handleMouseDown)
  },
  beforeDestroy () {
    // コンポーネント破棄時にイベントリスナーを削除
    this.$refs.slider.$el.removeEventListener('mousedown', this.handleMouseDown)
  },
  components: {
    VueSlider
  },
  methods: {
    data: function (maxPoint) {
      return [...Array(maxPoint)].map((_, i) => i + 1)
    },
    handleMouseDown: function (event) {
      console.log(this.serviceAnswerDetail.isFirstClick)
      if (this.serviceAnswerDetail.isFirstClick) {
        // 初回のクリックを検出し、スライダーの値を計算
        const rect = this.$refs.slider.$el.getBoundingClientRect()
        let clickPosition = (event.clientX - rect.left) / rect.width
        let newValue = 1
        if (clickPosition > 0) {
          newValue = Math.ceil(clickPosition * (this.$refs.slider.max - this.$refs.slider.min) + this.$refs.slider.min) || 1
        }
        this.$emit('handleMouseDown', newValue, this.index)
      }
    },
    handleChange: function (value) {
      if (!this.serviceAnswerDetail.isFirstClick) {
        this.$emit('handleChange', value, this.index)
      }
    }
  }
}
</script>
<style>
.vue-slider-mark {
  height: 16px!important;
  width: 16px!important;
}
.no-answer-slider .vue-slider-dot {
  display: none;
}
.vue-slider-mark-step {
  display: block!important;
}
.vue-slider-process {
  background-color: #DED516!important;
}
.vue-slider-dot-tooltip-inner {
  font-weight: bold;
  background-color: #DED516!important;
  border-color: #DED516!important;
}
.no-answer-warning {
  color: #ff0000;
  font-weight: bold;
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// ServiceAnswerEditSlider.vue?485721c2